import { useContext } from "react";
import { ToasterContext } from "./toaster_context";

function useToaster() {
  const { state, setState } = useContext(ToasterContext);

  const info = (title, message) => open(title, message, 1);
  const warn = (title, message) => open(title, message, 2);
  const error = (title, message) => open(title, message, 3);
  const success = (title, message) => open(title, message, 4);
  const open = (title, message, type) => {
    setState({
      show: true,
      title,
      message,
      type,
    });
  };
  const close = () => {
    setState({
      show: false,
      title: "",
      message: "",
      type: 0,
    });
  };
  return {
    info,
    warn,
    error,
    success,
    state,
    close,
  };
}
export default useToaster;
